import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { FormOptions, RadioQuestionOverride } from '@nx-customer-apps/shared/interfaces';
import { AdvancedSearch, Question, RadioQuestion, TextboxQuestion } from '@nx-customer-apps/shared/utils';
import { MonitoredDevicesComponent } from '../../../../heatload/monitored-devices/monitored-devices.component';

@Injectable({
    providedIn: 'root'
})
export class DeviceSelectionFormService {
    constructor() {}

    public getDeviceSelectionQuestions(formOptions?: FormOptions): Question[] {
        const conectedDeviceQueston = this.getConnectedDeviceQuestion(formOptions);
        return [conectedDeviceQueston];
    }

    public getConnectedDeviceQuestion(formOptions?: FormOptions) {
        const questions = [];

        const filterOverride = formOptions?.questions?.[FormKeys.Filter];
        const filter = new TextboxQuestion({
            value: filterOverride?.value,
            key: FormKeys.Filter,
            label: 'HEATLOAD.DEVICE_SELECTION.FILTER.LABEL',
            styles: 'pe-2 ca-device-filter ca-form-field-w-full'
        });
        questions.push(filter);

        const zipCodeOverride = formOptions?.questions?.[FormKeys.PostalCode];
        const zipCode = new TextboxQuestion({
            value: zipCodeOverride?.value,
            key: FormKeys.PostalCode,
            label: 'HEATLOAD.DEVICE_SELECTION.POSTAL_CODE.LABEL',
            styles: 'ps-2 ca-form-field-w-120'
        });
        questions.push(zipCode);

        const resultOverride = formOptions?.questions?.[FormKeys.Result] as RadioQuestionOverride;
        const resultQuestion = this.getConnectedDeviceResultQuestion(resultOverride);
        questions.push(resultQuestion);

        return new AdvancedSearch({
            groupName: FormKeys.ConnectedDevice,
            question: 'HEATLOAD.DEVICE_SELECTION.CENNECTED_DEVICE.TITLE',
            styles: 'ca-device-search',
            questions,
            content: MonitoredDevicesComponent,
            noResultsTitle: 'HEATLOAD.DEVICE_SELECTION.CENNECTED_DEVICE.NO_RESULTS.TITLE',
            noResultsDescription: 'HEATLOAD.DEVICE_SELECTION.CENNECTED_DEVICE.NO_RESULTS.DESCRIPTION'
        });
    }

    public getConnectedDeviceResultQuestion(override?: RadioQuestionOverride) {
        const question = new RadioQuestion({
            value: override?.value,
            question: 'HEATLOAD.DEVICE_SELECTION.RESULT.TITLE',
            validators: [Validators.required],
            label: 'HEATLOAD.DEVICE_SELECTION.RESULT.LABEL',
            key: FormKeys.Result,
            styles: 'ca-radio-single-column ca-radio-width-full',
            options: override?.options || []
        });
        return question;
    }
}
